import React, { Component } from "react"
import { 
  Label, Input, FormGroup, Button, Container, Row, Col, InputGroupAddon,
  Modal, ModalFooter, ModalHeader, ModalBody, InputGroup 
} from "reactstrap";
import Select from "react-select";
import { Download } from "react-feather";
import classnames from "classnames"
import PerfectScrollbar from "react-perfect-scrollbar"
import CustomerActivityCard from "../elements/customerActivityCard";
import LibraryCarousel from "./components/libraryCarousel";
import Invite from "../elements/newInvite";

import CustomerSelector from "../elements/customerSelector";

import { inject, observer } from 'mobx-react';
import { withFirebase } from '../../services/Firebase';
import LibraryStore from "../../stores/libraryStore";

const customers = ["Akash", "Nikhil", "Vinay", "Sidharth", "John Doe", "Alex"];

@inject( 'libraryStore', 'sessionStore')
@observer
class ShareContent extends Component {

  state = {
    customerName: "",
    shareCode: "",
    uid: "",
    showCustomerModal: false,
  }

  componentDidMount = () => {
    const { libraryStore } = this.props;
    libraryStore.loadCustomers();
  }

  setCustomer = (o) => {
    const { libraryStore } = this.props;
    libraryStore.setCustomer(o.value);
  }

  closePage = () => {
    this.setState({
      customerSelected: false
    })
    this.props.closeSharePage();
  }

  generateShareCode = (customerName, uid) => {
    const { libraryStore } = this.props;
    libraryStore.createShareableLink(customerName, uid)
  }

  toggleCustomerModal = () => {
    this.setState((prevState) => ({
      showCustomerModal: !prevState.showCustomerModal
    }))
  }

  shareDocument = (shareVia) => {
    const { libraryStore, sessionStore } = this.props;
    const { authUser } = sessionStore
    libraryStore.shareDocument(shareVia, authUser);
  }

  render() {
    const { libraryStore, show } = this.props;
    const { customers, customer, document } = libraryStore;
    const custOptions = customers.length ? customers.map((cust) => {
      return { value: cust, label: cust.account.firstName + " " + cust.account.lastName }
    }) : []
    const activeDocumentId = document && document.uid ? document.uid : null;
    const activeCustomerId = customer && customer.uid ? customer.uid : null;
    const cusName = activeCustomerId ? `${customer.account.firstName} ${customer.account.lastName }` : "" ;
    const selectedCustomerIndex = activeCustomerId ? custOptions.findIndex((cust) => cust.value.uid === activeCustomerId) : null;
    const { shareableLink } = libraryStore;

    const customerModal = (<Modal
      isOpen={this.state.showCustomerModal}
      className="modal-dialog-centered modal-xl"
    >
      <div className="sidebar_header">
        <span className="heading">Select Content</span>
        <div>
          <Button
            color="danger"
            outline
            className="btn ml-1"
            onClick={this.toggleCustomerModal}
          >
            Cancel
            </Button>
        </div>
      </div>
      <div className="sidebar_content">
        <CustomerSelector
          contentSharing="library"
          toggle={this.toggleCustomerModal}
        />
      </div>
    </Modal>)

   
    const renderContactSection = <div>

      <FormGroup>
        <Label for="customer">Select Customer</Label>
        <InputGroup>
          <Input
            type="text"
            placeholder="Select Customer"
            value={cusName}
          />
          <InputGroupAddon addonType="append">
            <Button
              className="button"
              color="primary"
              onClick={this.toggleCustomerModal}
            >
              Select Customer
            </Button>
          </InputGroupAddon>
        </InputGroup>
      </FormGroup>

      {/* <FormGroup>
        <Label for="customer">Customer</Label>
        <Select
          className="React"
          id="customer"
          value={custOptions[selectedCustomerIndex]}
          classNamePrefix="select"
          name="loading"
          onChange={o => this.setCustomer(o)}
          options={custOptions}
          isLoading={false}
        />
      </FormGroup> */}
      {
        activeCustomerId
          ? <CustomerActivityCard
            customerName={customer.account.firstName + " " + customer.account.lastName}
            data={[
              {
                title: "Last Meeting",
                value: "10 days ago"
              },
              {
                title: "Content shared in this week",
                value: "3 times"
              }, {
                title: "Overall sharing frequency",
                value: "4/week"
              },
              {
                title: "Engagement Rating",
                value: "3.45"
              }
            ]}
          />
          : null
      }
      <div className="mt-3">
        {
          activeDocumentId
            ? <LibraryCarousel
              data={document.pages}
              fileName={document.fileName}
              contentType={document.contentType}
              fileSize={document.size}
            />
            : null
        }
      </div>
    </div>

    return (
      <div
        className={classnames("share-content-sidebar", {
          show: show
        })}>
        <PerfectScrollbar options={{ wheelPropagation: false }}>
          <div className="library-content-view">
            <div className="content-view-header flex-wrap">
              <h3 className="textCapitalize">{document.name}</h3>
              <Button
                className="ml-1"
                color="danger"
                outline
                onClick={this.closePage}>
                Cancel
            </Button>
            </div>
            <Container>
              <Row className="mt-4">
                <Col xs={12} md={6} lg={5} style={{height: "100%"}}>
                  {renderContactSection}
                </Col>
                <Col xs={12} md={6} lg={7}>
                  {
                    activeCustomerId
                      ? <div className="d-flex justify-content-center" style={{ height: "100%" }}>
                        <Invite
                          shareable_link={shareableLink}
                          customer_name={this.state.customerName}
                          content_title={document.name}
                          generateCode={(e) => this.generateShareCode(custOptions[selectedCustomerIndex].label, activeCustomerId)}
                          share={ (shareVia) => this.shareDocument(shareVia)}
                        />
                      </div>
                      :<div className="d-flex justify-content-center align-items-center" style={{height: "100%"}}>
                          <h4 className="text-muted">Select customer to share content with...</h4>
                      </div>
                  }
                </Col>
              </Row>
            </Container>
          </div>
        </PerfectScrollbar>

        {customerModal}

      </div>
    );
  }
}

export default ShareContent;
